import { render, staticRenderFns } from "./TermsContractPage.vue?vue&type=template&id=09440ee7&scoped=true"
import script from "./TermsContractPage.vue?vue&type=script&lang=js"
export * from "./TermsContractPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09440ee7",
  null
  
)

export default component.exports